import {baseImageUrl, baseChatImageUrl} from "../services/AxiosInstance";

/**
 * Construit une URL de document sécurisée
 * @param {string} imageUri - Le chemin ou l'URI de l'image
 * @param {string} baseUrl - L'URL de base (par défaut: baseImageUrl)
 * @returns {string|null} - L'URL complète ou null si imageUri est invalide
 */
export const buildImageUrl = (imageUri, baseUrl = baseImageUrl) => {
  if (!imageUri || typeof imageUri !== "string" || imageUri.trim() === "") {
    return null;
  }

  const value = imageUri.trim();

  // OAuth providers and some legacy records already contain a complete URL.
  if (/^(?:https?:|data:|blob:)/i.test(value)) {
    return value;
  }

  const normalizedBaseUrl = String(baseUrl || "").replace(/\/+$/, "");
  let normalizedUri = value.replace(/^\/+/, "");

  // Support filename-only values as well as historical document/file.jpg and
  // uploads/document/file.jpg paths without duplicating the public directory.
  try {
    const publicDirectory = new URL(normalizedBaseUrl).pathname
      .replace(/^\/+|\/+$/g, "")
      .split("/")
      .filter(Boolean)
      .pop();

    if (publicDirectory) {
      const escapedDirectory = publicDirectory.replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&",
      );
      normalizedUri = normalizedUri.replace(
        new RegExp(`^(?:uploads/)?${escapedDirectory}/`, "i"),
        "",
      );
    }
  } catch (_) {
    // Keep the path untouched if a custom non-URL base is supplied.
  }

  return `${normalizedBaseUrl}/${normalizedUri}`;
};

/**
 * Construit une URL de chat sécurisée
 * @param {string} chatPath - Le chemin de l'image de chat
 * @returns {string|null} - L'URL complète ou null si chatPath est invalide
 */
export const buildChatImageUrl = (chatPath) => {
  return buildImageUrl(chatPath, baseChatImageUrl);
};
